module.exports = __webpack_public_path__ + "static/media/argumentacao01.99aca2da.md";